import { gql } from "@apollo/client";

export interface LCTerminalRow {
  activations: number;
  periodecomp: number;
  skipTime: number | string;
  skipCnt: number;
  terminalType: number;
  port: number;
}

export const LC_TERMINAL_ROWS = gql`
  query LcTerminalRows($domain: String!, $terminalIds: [Int!]!) {
    controller {
      lcTerminalRows(domain: $domain, terminalIds: $terminalIds) {
        activations
        periodecomp
        skipTime
        skipCnt
        terminalType
        port
      }
    }
  }
`

export interface LCTerminalRowsResponse {
  controller: {
    lcTerminalRows: LCTerminalRow[];
  }
}

export interface LCTerminalRowsArgs {
  domain: string;
  terminalIds: number[];
}